import type { SimplePaletteColorOptions } from '@mui/material'

const Color: Pick<SimplePaletteColorOptions, 'main'> = {
  main: '#146EB4',
}

export default Color
